import React, { useEffect } from "react";
import styles from "./Dialog.module.css";

export interface DialogProps {
  open: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  size?: "small" | "medium" | "large";
  maxWidth?: string;
  maxHeight?: string;
  className?: string;
}

export const Dialog: React.FC<DialogProps> = ({
  open,
  onClose,
  children,
  size = "medium",
  maxWidth,
  maxHeight,
  className,
}) => {
  // Handle escape key
  useEffect(() => {
    if (!open) return;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [open, onClose]);

  // Prevent body scroll when dialog is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  const handleBackdropClick = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      onClose?.();
    }
  };

  const containerStyle = {
    ...(maxWidth && { maxWidth }),
    ...(maxHeight && { maxHeight }),
  };

  return (
    <dialog className={styles.Dialog} open>
      <div className={styles.Wrapper} onClick={handleBackdropClick}>
        <div
          className={`${styles.Container} ${styles[size]} ${className || ""}`}
          style={containerStyle}
        >
          {children}
        </div>
      </div>
    </dialog>
  );
};
